
namespace TabAurous.Inventory {

    @Serenity.Decorators.registerClass()
    export class BranchOutTaxDialog extends Common.GridEditorDialog<BranchOutTaxRow> {
        protected getFormKey() { return BranchOutTaxForm.formKey; }
        //protected getIdProperty() { return BranchOutTaxRow.idProperty; }
        protected getLocalTextPrefix() { return BranchOutTaxRow.localTextPrefix; }
        protected getNameProperty() { return BranchOutTaxRow.nameProperty; }
        //protected getService() { return BranchOutTaxService.baseUrl; }
        protected getDeletePermission() { return BranchOutTaxRow.deletePermission; }
        protected getInsertPermission() { return BranchOutTaxRow.insertPermission; }
        protected getUpdatePermission() { return BranchOutTaxRow.updatePermission; }

        protected form = new BranchOutTaxForm(this.idPrefix);

        constructor() {
            super();
            q.setTextRightAlign(this.form.NetAmount);
            q.setTextRightAlign(this.form.TaxRate);
            q.setTextRightAlign(this.form.TaxAmount);

        }

    }
}